import 'styles/Footer.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'
import classNames from 'classnames'
require('font-awesome-webpack')

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newsletterIsActive: false,
      formValue: '',
      footerIsHidden: false,
      isNavigateGallery: false
    }
  }
  toggleNewsletter = () => {
    if (!this.state.newsletterIsActive) {
      this.interval = window.setInterval(this.closeWhenIdle.bind(this), 3000)
    }

    this.setState({
      newsletterIsActive: !this.state.newsletterIsActive,
      formValue: ''
    })
  }
  closeWhenIdle() {
    if (this.state.newsletterIsActive && this.state.formValue.length === 0) {
      this.setState({newsletterIsActive: false})
      window.clearInterval(this.interval)
    }
  }
  // Certain paths need to hide the footer (e.g. /camps/2016)
  componentWillReceiveProps(nextProps) {
    this.setState({
      footerIsHidden: nextProps.footerIsHidden,
      isNavigateGallery: nextProps.isNavigateGallery
    })
  }
  handleChange = (e) => {
    this.setState({
      formValue: e.target.value
    })
  }
  render() {
    if (this.state && (this.state.footerIsHidden || this.state.isNavigateGallery)) {
      return null
    }

    let button
    if (this.state.error) {
      button = <h5 className="error fade-in">{this.state.error}</h5>
    } else {
      button = <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="submit-button fade-in"/>
    }

    let inputClassName = 'email'
    if (this.state && this.state.formValue.length > 0) {
      inputClassName = `${inputClassName} footer-email-active`
    }
    const mobile = (window.innerWidth <= 480)
    if (mobile) {
      inputClassName += ' footer-email-mobile'
    }

    let newsletter = <button className="fade-in" onClick={this.toggleNewsletter}>Sign up for our newsletter</button>
    if (this.state.newsletterIsActive) {
      newsletter = (
        <div id="mc_embed_signup" className="newsletter-box group fade-in">
          <form action="//gakkoproject.us4.list-manage.com/subscribe/post?u=fa4319fecd8b40e74b6a3ee7b&amp;id=477d0e625d" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
            <div id="mc_embed_signup_scroll">
              <input type="email" value={this.state.formValue} onChange={this.handleChange} name="EMAIL" className={inputClassName} id="mce-EMAIL" placeholder="you@email.com" required autoFocus />

              <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                <input type="text" name="b_fa4319fecd8b40e74b6a3ee7b_477d0e625d" tabIndex="-1" value=""/>
              </div>
              
              <div className="clear">
                {button}
              </div>
            </div>
          </form>
        </div>
      )
    }

    return (
      <div className='footer-component'>
        <div className="footer-social group">
          <a href="https://vimeo.com/gakkoproject" target="_blank"><i className="fa fa-vimeo-square" aria-hidden="true"></i></a>
          <a href="https://www.instagram.com/gakko_camp/" target="_blank"><i className="fa fa-instagram" aria-hidden="true"></i></a>
          <a href="https://www.facebook.com/GAKKOPROJECT/" target="_blank"><i className="fa fa-facebook-square" aria-hidden="true"></i></a>
        </div>
        {newsletter}
        <h5><a href='mailto:hello@gakkoproject.com?Subject=Hello%20'>hello@gakkoproject.com</a></h5>
      </div>
    )
  }
}
Footer.contextTypes = {
}
Footer.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    footerIsHidden: state.token.footerIsHidden,
    isNavigateGallery: state.token.isNavigateGallery
  }
}

export default connect(mapStateToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Utils/Footer.js